import classes from "./RepeatDelivery.module.css";
import { InputElement } from "../inputElement/InputElement";
import { SelectElement } from "../selectElement/SelectElement";
import { InputCheckbox } from "../inputCheckbox/InputCheckbox";
import { getCurrentDate } from "../../helperFunctions/getCurrentDate";
import { setPackageForm } from "../../redux/forms/packageForm";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { useDispatch, useSelector } from "react-redux";

export function RepeatDelivery() {
  const { t } = useTranslations();
  const text = t.repeatDelivery;

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.forms.packageForm);
  const { isEditMode } = useSelector((state) => state.global);

  const handleSelectChange = (e) => {
    let { name, value } = e.target;

    dispatch(setPackageForm({ [name]: value }));
  };

  const handleWeekdayToggle = (dayCode) => {
    // Ensure we always have an array to work with
    const currentWeekdays = Array.isArray(formData.selectedWeekdays)
      ? formData.selectedWeekdays
      : [];

    const updatedWeekdays = currentWeekdays.includes(dayCode)
      ? currentWeekdays.filter((d) => d !== dayCode)
      : [...currentWeekdays, dayCode];

    dispatch(setPackageForm({ selectedWeekdays: updatedWeekdays }));
  };

  const numberOptions = Array.from({ length: 30 }, (_, i) =>
    (i + 1).toString()
  );

  const intervalOptions = [
    {
      label: text.daily,
      value: "Daily",
    },
    {
      label: text.weekly,
      value: "Weekly",
    },
    {
      label: text.monthly,
      value: "Monthly",
    },
  ];

  const endsOptions = [
    { label: text.never, value: "never" },
    { label: text.specificDay, value: "until" },
  ];

  // Calculate minimum end date - 1 day after start date or today.
  function getMinEndDate() {
    if (formData.date) {
      const nextDay = new Date(formData.date);
      nextDay.setDate(nextDay.getDate());
      return nextDay.toISOString().split("T")[0];
    }
    return getCurrentDate();
  }

  return (
    <form className={classes.form}>
      <div className={classes.selects}>
        <SelectElement
          name="everyType"
          placeholder={text.interval}
          width={"150px"}
          value={formData.everyType}
          options={intervalOptions}
          onChange={handleSelectChange}
          maxHeight={"120px"}
          optionLabelKey={"label"}
          optionValueKey={"value"}
          disabled={isEditMode}
        />
        {formData.everyType === "Monthly" && (
          <SelectElement
            name="everyNumber"
            placeholder={text.every}
            width={"150px"}
            value={formData.everyNumber}
            options={numberOptions}
            onChange={handleSelectChange}
            maxHeight={"120px"}
            disabled={isEditMode}
          />
        )}
        <SelectElement
          name="ends"
          placeholder={text.ends}
          width={"150px"}
          value={formData.ends}
          options={endsOptions}
          onChange={handleSelectChange}
          maxHeight={"120px"}
          optionLabelKey={"label"}
          optionValueKey={"value"}
          disabled={isEditMode}
        />
        {formData.ends !== "never" && formData.ends !== "" && (
          <InputElement
            labelText={text.endDate}
            id="endDate"
            name="endDate"
            value={formData.endDate}
            type="date"
            min={getMinEndDate()}
            disabled={isEditMode}
            onChange={(e) =>
              handleSelectChange({
                target: { name: "endDate", value: e.target.value },
              })
            }
          />
        )}
      </div>
      {formData.everyType === "Weekly" && (
        <div className={classes.checks}>
          {text.days.map((day, index) => (
            <InputCheckbox
              key={index}
              label={day.label}
              disabled={isEditMode}
              checked={
                formData.selectedWeekdays !== null &&
                formData.selectedWeekdays.includes(day.value)
              }
              onChange={() => handleWeekdayToggle(day.value)}
            />
          ))}
        </div>
      )}
      <h5 style={{ color: "red" }}>{text.note}</h5>
    </form>
  );
}
